'use client';

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useRef } from 'react';
import BlogListItem from '@/components/molecules/BlogListItem';
import { FilterPill } from '@/components/molecules/FilterPill';
import { ContentProps } from './types';
import { filterBlogsByCategory } from './utils';
const BlogPostsWithFiltersContent = t0 => {
  const $ = _c(6);
  const {
    filters,
    blogs
  } = t0;
  const pathname = usePathname();
  const router = useRouter();
  const currentSearchParams = useSearchParams();
  const activeFilter = currentSearchParams?.get("filter") || filters[0];
  const filteredItems = filterBlogsByCategory(blogs, activeFilter);
  const filtersContainerRef = useRef(null);
  let t1;
  if ($[0] !== currentSearchParams || $[1] !== pathname || $[2] !== router) {
    t1 = filter => {
      const updatedSearchParams = new URLSearchParams(currentSearchParams?.toString() || "");
      if (filter.includes("All")) {
        updatedSearchParams.delete("filter");
      } else {
        updatedSearchParams.set("filter", filter);
      }
      router.push(pathname + "?" + updatedSearchParams.toString(), {
        scroll: false
      });
    };
    $[0] = currentSearchParams;
    $[1] = pathname;
    $[2] = router;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const updateFilter = t1;
  const t2 = "mb-10 flex flex-wrap gap-8 lg:mb-12 lg:flex-row lg:gap-5";
  const t3 = filteredItems.map(_temp);
  let t4;
  if ($[4] !== t3) {
    t4 = <div className={t2}>{t3}</div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return <><div className="no-scrollbar mb-[3.75rem] flex flex-row gap-2 overflow-x-scroll" ref={filtersContainerRef}>{filters.map((filter_0, index) => <FilterPill key={filter_0} isActive={activeFilter === filter_0} label={filter_0} onClick={() => {
        const scrollLeft = filtersContainerRef.current?.scrollLeft || 0;
        const pillWidth = filtersContainerRef.current?.children[index]?.clientWidth || 0;
        const pillOffset = filtersContainerRef.current?.children[index]?.offsetLeft || 0;
        const scrollOffset = pillOffset - scrollLeft;
        const halfPillWidth = pillWidth / 2;
        const scrollPosition = scrollOffset - halfPillWidth;
        filtersContainerRef.current?.scrollBy({
          left: scrollPosition,
          behavior: "smooth"
        });
        updateFilter(filter_0);
      }} className="transition-all" />)}</div>{t4}</>;
};
export default BlogPostsWithFiltersContent;
function _temp(item) {
  return <BlogListItem key={item.id} {...{
    item
  }} />;
}